// extracted by mini-css-extract-plugin
export default {"numberFieldWithFlexibility":"numberFieldWithFlexibility__Y2Q2Y","checkbox":"checkbox__Y2EwZ"};